import { Injectable } from '@angular/core';

@Injectable()
export class AlterarSenhaService {
  private senha: string;

  senhaParaTroca(senha: string = null) {
    //console.log(senha);
    if (senha) {
      return this.senha = senha;
    }
    return this.senha;
  }

}
